import { Component, EventEmitter, OnInit, Output, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  CompName,
  constantStrings,
  ROLE,
  STATUSCODESTRING,
  statusCode
} from '@shared/helpers/constants';
import { AuthService } from '@shared/services/auth.service';
import { CasedashboardService } from '../casedashboard.service';
import { DialogData } from '../header/header.component';

@Component({
  selector: 'app-casefilterdialog',
  templateUrl: './casefilterdialog.component.html',
  styleUrls: ['./casefilterdialog.component.scss'],
})
export class CasefilterdialogComponent implements OnInit {
  public anatomy: any = [];
  public type: any = [];
  public status: any = [];
  public assigned: any = [];
  public imagecenter: any = [];

  public showanatomy: boolean = false;
  public showtype: boolean = false;
  public showStatus: boolean = false;
  public showassigned: boolean = false;
  public showduedate: boolean = false;
  public showimagecenter: boolean = false;
  public showcompleteddate: boolean = false;
  itemSelected: string | undefined;
  public today: Date = new Date();
  public maxDate: Object = new Date(this.today);
  startDate!: '';
  endDate: '' | undefined;
  //event emmitter to emit an event and pass the parameters on emit to another component receiving value
  @Output() event = new EventEmitter<any>();
  public showStartDate: boolean = false;
  public showEndDate: boolean = false;
  public showStartDateDue: boolean = false;
  public showEndDateDue: boolean = false;
  selectedStart: Date | undefined;
  selectedEnd: Date | undefined;
  selectedStartDueDate: Date | undefined;
  selectedEndDueDate: Date | undefined;
  minDate: Date | undefined;
  minDateDue: Date | undefined;
  chosenDateFlag: boolean = false;
  loggedInUser: string | undefined;
  componentName: string | undefined;
  activeImgFlag: boolean = false;
  completeDateFlag: boolean = false;
  caseHisFlag: boolean = false;
  activeHilFlag: boolean = false;
  errinFilterValuesImage: [];
  errinFilterValuesClaimant: [];
  errinFilterValuesCaseDB: [];
  filterValuesCaseDBAPI: any;
  userInfo: any;
  displaySpinner: boolean = false;
  searchTextImg: string = '';
  searchTextAssign: string = '';
  imagecenterRes: any;
  assignToRes: any;
  caseStatus: any = [];
  caseStatusCodes: string = '';

  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<CasefilterdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private casedashboardService: CasedashboardService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const idToken = this.authService.getCognitoIdTokenFromStorage();
    const decodedValue = this.authService.decode(idToken);
    this.userInfo = decodedValue ? (decodedValue['cognito_old_username'] ? decodedValue['cognito_old_username'] : decodedValue['cognito:username'] ) : '';
    this.loggedInUser = decodedValue ? decodedValue['cognito:groups'][0] : '';

    if (this.loggedInUser == ROLE.SNN_HIL_REVIEWER) {
      if (this.data.compName === CompName.ACTIVE) {
        this.activeHilFlag = true;
        this.caseStatus = [
          STATUSCODESTRING.statusInReview,
          STATUSCODESTRING.statusNew,
          STATUSCODESTRING.statusUnclaimed,
        ];
      } else if (this.data.compName === CompName.MYCASES) {
        this.completeDateFlag = true;
        this.caseStatus = [
          STATUSCODESTRING.statusApproved,
          STATUSCODESTRING.statusRejected,
          STATUSCODESTRING.statusInReview,
          STATUSCODESTRING.statusError,
          STATUSCODESTRING.statusBoneModel,
        ];
      }
    } else if (this.loggedInUser == ROLE.SNN_HIL_MANAGER) {
      this.activeImgFlag = true;
      if (this.data.compName === CompName.ACTIVE) {
        this.activeHilFlag = true;
        this.caseStatus = [
          STATUSCODESTRING.statusInReview,
          STATUSCODESTRING.statusNew,
          STATUSCODESTRING.statusUnclaimed,
        ];
        this.caseStatusCodes = `${statusCode.INREVIEW},${statusCode.UNCLAIMED},${statusCode.NEW},${statusCode.BONE_MODEL_INITIATED}`;
      } else if (this.data.compName === CompName.CASEHISTORY) {
        this.completeDateFlag = true;
        this.caseHisFlag = true;
        this.caseStatus = [
          STATUSCODESTRING.statusApproved,
          STATUSCODESTRING.statusRejected,
          STATUSCODESTRING.statusError,
        ];
        this.caseStatusCodes = `${statusCode.APPROVED},${statusCode.REJECTED},${statusCode.ERROR},${statusCode.UPLOADED_TO_MIC},${statusCode.ON_TABLET},${statusCode.CASE_COMPLETE},${statusCode.FAILED},${statusCode.UPLOAD_PENDING},${statusCode.CASE_CANCEL}`;
      }
    }

    let userName = this.userInfo;
    if (
      this.casedashboardService.storedData == undefined ||
      this.casedashboardService.storedData?.status.length < 1
    ) {
      if (this.loggedInUser == ROLE.SNN_HIL_MANAGER) {
        this.getFilterValuesImage(this.caseStatusCodes);
      }
      this.getFilterValuesCaseDB(userName);
      this.getFilterValuesClaimant();
      for (let status of this.caseStatus) {
        let statusDetails = {
          status: status,
          statusId: this.casedashboardService.getCaseStatus(status),
          isSelected: false,
        };
        if (statusDetails.status == STATUSCODESTRING.statusInReview) {
          statusDetails.status = STATUSCODESTRING.statusInProgress;
        }
        if (statusDetails.status == STATUSCODESTRING.statusBoneModel) {
          statusDetails.status = STATUSCODESTRING.statusProcessing;
        }
        this.status.push(statusDetails);
      }
    } else {
      this.anatomy = this.casedashboardService.storedData.anatomy;
      this.type = this.casedashboardService.storedData.type;
      this.assigned = this.casedashboardService.storedData.assigned;
      this.imagecenter = this.casedashboardService.storedData.imagecenter;
      this.status = this.casedashboardService.storedData.status;
      this.selectedStart =
        this.casedashboardService.storedData.completedateStart;
      this.selectedEnd = this.casedashboardService.storedData.completedateEnd;
      this.selectedStartDueDate =
        this.casedashboardService.storedData.duedateStart;
      this.selectedEndDueDate = this.casedashboardService.storedData.duedateEnd;
      this.assignToRes = this.casedashboardService.storedData.assigned;
      this.imagecenterRes = this.casedashboardService.storedData.imagecenter;
    }
  }
  /**
   * This function handles the selection of dates and toggles the display of start and end date pickers.
   */
  dateChosen(event, key) {
    let eventPath = event.srcElement.className;
    let chosenStartDate = event.srcElement.innerHTML;
    if (this.selectedEnd) this.maxDate = this.selectedEnd;
    if (
      chosenStartDate >= 1 &&
      chosenStartDate <= 31 &&
      (eventPath.includes(
        'mat-calendar-body-cell-content mat-focus-indicator mat-calendar-body-selected'
      ) ||
        eventPath.includes(
          'mat-calendar-body-cell-content mat-focus-indicator mat-calendar-body-today mat-calendar-body-selected'
        ))
    ) {
      this.chosenDateFlag = true;
    } else {
      this.chosenDateFlag = false;
    }
    if (
      key == constantStrings.STARTDATE &&
      this.selectedStart &&
      this.chosenDateFlag
    ) {
      this.showStartDate = !this.showStartDate;
      this.minDate = this.selectedStart;
    } else if (
      key == constantStrings.ENDDATE &&
      this.selectedEnd &&
      this.chosenDateFlag
    ) {
      this.showEndDate = !this.showEndDate;
    }
    if (
      key == constantStrings.STARTDATEDUE &&
      this.selectedStartDueDate &&
      this.chosenDateFlag
    ) {
      this.showStartDateDue = !this.showStartDateDue;
      this.minDateDue = this.selectedStartDueDate;
    } else if (
      key == constantStrings.ENDDATEDUE &&
      this.selectedEndDueDate &&
      this.chosenDateFlag
    ) {
      this.showEndDateDue = !this.showEndDateDue;
    }
  }
  /**
   * The function toggles the visibility of different elements based on the ID passed as a parameter.
   */
  toggle(id) {
    switch (id) {
      case constantStrings.ANATOMY:
        this.showanatomy = !this.showanatomy;
        break;
      case constantStrings.TYPES:
        this.showtype = !this.showtype;
        break;
      case constantStrings.STATUS:
        this.showStatus = !this.showStatus;
        break;
      case constantStrings.IMAGECENTER:
        this.showimagecenter = !this.showimagecenter;
        break;
      case constantStrings.ASSIGNED:
        this.showassigned = !this.showassigned;
        break;
      case constantStrings.COMPLETEDDATE:
        this.showcompleteddate = !this.showcompleteddate;
        break;
      case constantStrings.STARTDATE:
        this.showStartDate = !this.showStartDate;
        this.showEndDate = false;
        break;
      case constantStrings.ENDDATE:
        this.showEndDate = !this.showEndDate;
        this.showStartDate = false;
        break;
      case constantStrings.DUEDATE:
        this.showduedate = !this.showduedate;
        break;
      case constantStrings.STARTDATEDUE:
        this.showStartDateDue = !this.showStartDateDue;
        break;
      case constantStrings.ENDDATEDUE:
        this.showEndDateDue = !this.showEndDateDue;
        break;
    }
  }
  /**
   * The function handles the selection of items and updates their corresponding isSelected property
   * based on the given id.
   */
  onSelect(selectItem, id) {
    this.itemSelected = selectItem;
    switch (id) {
      case constantStrings.anatomyGroup:
        for (let anatomy of this.anatomy) {
          if (this.itemSelected == anatomy.anatomyId) {
            anatomy.isSelected = true;
          }
        }
        break;
      case constantStrings.TYPES:
        for (let type of this.type) {
          if (this.itemSelected == type.typeId) {
            type.isSelected = true;
          }
        }
        break;
      case constantStrings.STATUS:
        for (let status of this.status) {
          if (this.itemSelected == status.statusId) {
            status.isSelected = true;
          }
        }
        break;
      case constantStrings.ASSIGNED:
        for (let assigned of this.assignToRes) {
          if (this.itemSelected == assigned.assignedId) {
            assigned.isSelected = true;
          }
        }
        break;
      case constantStrings.IMAGECENTER:
        for (let imagecenter of this.imagecenterRes) {
          if (this.itemSelected == imagecenter.imagecenterId) {
            imagecenter.isSelected = true;
          }
        }
        break;
      case constantStrings.STARTDATE:
      case constantStrings.ENDDATE:
      case constantStrings.STARTDATEDUE:
      case constantStrings.ENDDATEDUE:
        if (selectItem == null) {
          this.selectedStart = selectItem;
          this.selectedEnd = selectItem;
          this.minDate = selectItem;
        }
        break;
    }
  }
  /**
   * The function onDeSelect is used to deselect an item based on its ID and update its isSelected
   * property to false.
   */
  onDeSelect(selectItem, id) {
    this.itemSelected = selectItem;
    switch (id) {
      case constantStrings.anatomyGroup:
        for (let anatomy of this.anatomy) {
          if (this.itemSelected == anatomy.anatomyId) {
            anatomy.isSelected = false;
          }
        }
        break;
      case constantStrings.TYPES:
        for (let type of this.type) {
          if (this.itemSelected == type.typeId) {
            type.isSelected = false;
          }
        }
        break;
      case constantStrings.STATUS:
        for (let status of this.status) {
          if (this.itemSelected == status.statusId) {
            status.isSelected = false;
          }
        }
        break;
      case constantStrings.ASSIGNED:
        for (let assigned of this.assignToRes) {
          if (this.itemSelected == assigned.assignedId) {
            assigned.isSelected = false;
          }
        }
        break;
      case constantStrings.IMAGECENTER:
        for (let imagecenter of this.imagecenterRes) {
          if (this.itemSelected == imagecenter.imagecenterId) {
            imagecenter.isSelected = false;
          }
        }
        break;
    }
  }
  /**
   * The onSubmit function stores selected filters and closes a dialog box.
   */
  public onSubmit(): void {
    var selectedFiltersMaster = {
      anatomy: this.anatomy,
      type: this.type,
      status: this.status,
      assigned: this.assignToRes,
      duedateStart: this.selectedStartDueDate,
      duedateEnd: this.selectedEndDueDate,
      completedateStart: this.selectedStart,
      completedateEnd: this.selectedEnd,
      imagecenter: this.imagecenterRes,
    };
    this.casedashboardService.storedData = selectedFiltersMaster;
    this.dialogRef.close(selectedFiltersMaster);
  }
  /**
   * The function clears all arrays and filter data in a casedashboard service.
   */
  public clearAll() {
    this.clearArray(this.imagecenter);
    this.clearArray(this.assigned);
    this.clearArray(this.status);
    this.clearArray(this.anatomy);
    this.clearArray(this.type);
    this.clearCompletedDate();
    this.clearDueDate();
    this.casedashboardService.ClearFilterData();
  }
  /**
   * The function clears the selected start and end dates.
   */
  public clearCompletedDate() {
    this.selectedStart = undefined;
    this.selectedEnd = undefined;
  }
  /**
   * The function clears the selected start and end due dates.
   */
  public clearDueDate() {
    this.selectedStartDueDate = undefined;
    this.selectedEndDueDate = undefined;
  }
  /**
   * The function clears the "isSelected" property of each object in an array.
   */
  clearArray(Arr) {
    let dataArray = Arr;
    if(dataArray != undefined){
      dataArray.map((data, i) => {
        dataArray[i].isSelected = false;
      });
    }
  }
  /**
   * This function filters an array of image centers based on a search string.
   */
  searchImgCenter() {
    let searchString = this.searchTextImg.toLowerCase();
    if (searchString != undefined && searchString != '') {
      this.imagecenter = this.imagecenterRes.filter((obj) => {
        if (obj?.imagecenterName.toLowerCase().includes(searchString)) {
          return true;
        } else return false;
      });
    } else {
      this.imagecenter = this.imagecenterRes;
    }
  }
  /**
   * This function searches for assigned items based on a given search string and filters the results
   * accordingly.
   */
  searchAssignedTo() {
    let searchString = this.searchTextAssign.toLowerCase();
    if (searchString != undefined && searchString != '') {
      this.assigned = this.assignToRes.filter((obj) => {
        if (obj?.assignedName.toLowerCase().includes(searchString)) {
          return true;
        } else return false;
      });
    } else {
      this.assigned = this.assignToRes;
    }
  }
  getFilterValuesImage(statuscode) {
    this.casedashboardService.getFilterValuesImage(statuscode).subscribe({
      next: (Response) => {
        let result = Response;
        for (let image of result) {
          let imageDetails = {
            imagecenterId: image.sourceFacilityId,
            imagecenterName: image.sourceFacilityName,
            isSelected: false,
          };
          this.imagecenter.push(imageDetails);
        }
        this.imagecenterRes = this.imagecenter;
      },
      error: (error) => {
        this.errinFilterValuesImage = error;
      },
    });
  }
  /**
   * This function retrieves filter values for claimants and assigns them to an array.
   */
  getFilterValuesClaimant() {
    let params = {
      statuscodes: [8, 9, 15],
      casecategory: 1,
    };
    this.casedashboardService.getFilterValuesClaimant(params).subscribe({
      next: (Response) => {
        let result = Response;
        for (let claimant of result) {
          if(claimant.claimantUserName){
          let claimantDetails = {
            assignedId: claimant.claimantUserName,
            assignedName:
              claimant.claimantFirstName + ' ' + claimant.claimantLastName,
            isSelected: false,
          };
          this.assigned.push(claimantDetails);
         }
        }
        this.assignToRes = this.assigned;
      },
      error: (error) => {
        this.errinFilterValuesClaimant = error;
      },
    });
  }
  /**
   * This function retrieves filter values for a case dashboard from an API and populates them in the
   * corresponding arrays.
   */
  getFilterValuesCaseDB(userName) {
    this.displaySpinner = true;
    this.casedashboardService.getFilterValuesCaseDB(userName).subscribe({
      next: (Response) => {
        let result = Response;
        this.filterValuesCaseDBAPI = result;
        this.displaySpinner = false;
        for (let anatomy of this.filterValuesCaseDBAPI.anatomy) {
          let anatomyDetails = {
            anatomyId: anatomy,
            anatomyName: anatomy,
            isSelected: false,
          };
          this.anatomy.push(anatomyDetails);
        }
        for (let type of this.filterValuesCaseDBAPI.imagingType) {
          let typeDetails = {
            typeId: type,
            type: type,
            isSelected: false,
          };
          this.type.push(typeDetails);
        }
      },
      error: (error) => {
        this.errinFilterValuesCaseDB = error;
        this.displaySpinner = false;
      },
    });
  }
}
